import { render, staticRenderFns } from "./EditWhatsapp.vue?vue&type=template&id=1436bdfe&scoped=true&"
import script from "./EditWhatsapp.vue?vue&type=script&lang=js&"
export * from "./EditWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./EditWhatsapp.vue?vue&type=style&index=0&id=1436bdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436bdfe",
  null
  
)

export default component.exports